import {
  UserFull,
  UserStatus,
  UserInvitation,
  CompanyUser,
  CompanyRole,
} from '@/models/users'
import { MutationTree } from 'vuex'
import { UserState } from './state'

import { localStorageSet } from '@/helpers/localStorage'

export enum UserMutationTypes {
  SetCurrentUser = '[User Mutation] Set Current User', // _USERS__ME_GET shared
  Filter = '[User Mutation] Filter', // _USERS__FILTER
  Save = '[User Mutation] Save', // _USERS__SAVE shared
  SaveInvitations = '[User Mutation] Save Invitations', // _USERS__SAVE_INVITATIONS shared
  SaveRoles = '[User Mutation] Save Roles', // _USERS__SAVE_ROLES
  SetActiveCompany = '[User Mutation] Set Active Company', // _USERS__SET_ACTIVE_COMPANY shared
}

export const mutations: MutationTree<UserState> = {
  /**
   * Persist user's active company
   *
   * @param {UserState} state
   * @param {string} id
   */
  [UserMutationTypes.SetActiveCompany](state: UserState, id: string) {
    state.me.company = id
    localStorageSet('company', id)
  },

  /**
   * Persist users list filter value
   *
   * @param {UserState} state
   * @param {UserStatus} status
   */
  [UserMutationTypes.Filter](state: UserState, status: UserStatus) {
    state.filter = status
  },

  /**
   * Persist company's invitations list
   *
   * @param {UserState} state
   * @param {UserInvitation[]} list
   */
  [UserMutationTypes.SaveInvitations](
    state: UserState,
    list: UserInvitation[],
  ) {
    state.invitations = list
  },

  /**
   * Persist company's users list
   *
   * @param {UserState} state
   * @param {CompanyUser[]} list
   */
  [UserMutationTypes.Save](state: UserState, list: CompanyUser[]) {
    state.list = list
  },

  /**
   * Saves current user in store
   *
   * @param {UserState} state
   * @param {UserFull} user
   */
  [UserMutationTypes.SetCurrentUser](state: UserState, user: UserFull) {
    state.me = user
  },

  /**
   * Persist company's roles list
   *
   * @param {UserState} state
   * @param {CompanyRole[]} roles
   */
  [UserMutationTypes.SaveRoles](state: UserState, roles: CompanyRole[]) {
    state.roles = roles
  },
}
